import { render, staticRenderFns } from "./TsProfilePanel.vue?vue&type=template&id=432a2ae2"
import script from "./TsProfilePanel.vue?vue&type=script&lang=ts"
export * from "./TsProfilePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports